import { Column } from '../../../../core/components/Column';
import { TextComponent } from '../../../../core/components/TextComponent';
import { XCloseGray } from '../../../../core/icons/XClose';

interface ModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onSubmit?: () => void;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export const ContainerModal: React.FC<ModalProps> = ({
  isOpen,
  onRequestClose,
  title,
  subtitle,
  footer,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-[#0000006b] z-20"></div>
      <article
            className={"fixed z-30 top-0 left-0 w-full sm:w-[38rem] h-full sm:h-auto sm:max-h-[43rem] sm:top-1/2 sm:left-1/2 transform sm:-translate-x-1/2 sm:-translate-y-1/2 transition-transform"}
      >
        <Column
                className="w-full sm:w-[38rem] h-full sm:max-h-[30rem] bg-black overflow-y-auto gap-4 sm:gap-5 sm:rounded-xl"
            >
          <button
            onClick={onRequestClose}
            className="max-sm:text-black max-sm:hover:text-black/50 text-white hover:text-grayLight2 absolute z-30 top-5 sm:top-0 right-5 sm:-right-8 max-sm:self-end"
            aria-label="Close"
          >
            <XCloseGray />
          </button>

          <Column
            className="w-full h-full sm:max-h-[43rem] overflow-y-auto bg-white flex flex-col"
            crossAxisAlignment='center'
          >
            <Column className="pt-20 px-6 sm:px-16">
              {title && (
                <TextComponent variant="h2" className="font-bold text-center mb-2">
                  {title}
                </TextComponent>
              )}
              {subtitle && (
                <TextComponent variant="h6" className="text-center text-[#6B6B6B]">
                  {subtitle}
                </TextComponent>
              )}
            </Column>
            <div className="flex-1 w-full pt-12 px-6 sm:px-24">
              {children}
            </div>
            {footer && (
              <div className="w-full pt-24 px-6 sm:px-24 pb-16">
                {footer}
              </div>
            )}
          </Column>
        </Column>
      </article>
      </>
  );
};
